import { useEffect, useState } from 'react';

const FF_OVERRIDE_PREFIX = 'ff_override_';
const OVERRIDE_CHANGED_EVENT = 'ff_override_changed';

/** Returns true/false if a local override is set, null if using the server value. */
export function getFFOverride(module: string): boolean | null {
  let stored: string | null;
  try {
    stored = localStorage.getItem(`${FF_OVERRIDE_PREFIX}${module}`);
  } catch {
    return null;
  }
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return null;
}

/** Set a local override. Pass null to clear and fall back to the server value. */
export function setFFOverride(module: string, value: boolean | null): void {
  try {
    if (value === null) {
      localStorage.removeItem(`${FF_OVERRIDE_PREFIX}${module}`);
    } else {
      localStorage.setItem(`${FF_OVERRIDE_PREFIX}${module}`, value ? 'true' : 'false');
    }
  } catch {
    return;
  }
  window.dispatchEvent(new Event(OVERRIDE_CHANGED_EVENT));
}

/** Returns a counter that increments whenever any FF override changes, so callers re-render. */
export function useFFOverrideRevision(): number {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const handler = () => setRevision((r) => r + 1);
    window.addEventListener(OVERRIDE_CHANGED_EVENT, handler);
    return () => window.removeEventListener(OVERRIDE_CHANGED_EVENT, handler);
  }, []);
  return revision;
}
